export default __webpack_public_path__ + "static/media/lg5.c6a5be5e.jpg";